import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/1234567890" // Replace with actual number
  target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:bg-[#1ebe57] transition-colors flex items-center justify-center group" whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} initial={{
    opacity: 0,
    scale: 0
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    delay: 1,
    type: 'spring'
  }} data-id="element-327">
      <MessageCircle className="w-8 h-8" data-id="element-328" />
      <span className="absolute right-full mr-4 bg-white text-gray-800 text-sm font-semibold py-2 px-4 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-329">
        ¿Tienes dudas? Escríbenos
      </span>
    </motion.a>;
}